import { post } from "../axios";
import router from "../../router/index";

const getAppid = url => {
  console.log(location.href);
  // url = location.href
  const hid = sessionStorage.getItem("hid");
  post("member/login/getAppid", { hid }).then(res => {
    url = encodeURIComponent(url);
    const appid = res.appid;
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
  });
};

const login = code => {
  return new Promise((resolve, reject) => {
    const hid = sessionStorage.getItem("hid");
    post("member/login/login", { code, hid }).then(res => {
      console.log(res);
      switch (res.type) {
        // 登录成功 // openid 有  hid有
        case 1:
          sessionStorage.setItem("token", res.token);
          resolve(1);
          break;
        // 跳注册页 openid 没  hid有
        case 2:
          const data = JSON.stringify(res);
          sessionStorage.setItem("bindInfo", data);
          router.push({ path: "/enter" });
          resolve(2);
          break;
        // 弹框提示  openid 没 hid没
        case 3:
          console.log(3);
          router.push({ path: "/bandinfo" });
          resolve(3);
          break;
      }
    });
  });
};

export default {
  getAppid,
  login
};



// WEBPACK FOOTER //
// ./src/Interface/api/login.js